import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { InteriorDetailingPage } from './pages/InteriorDetailingPage';
import { ExteriorDetailingPage } from './pages/ExteriorDetailingPage';
import { FullCarDetailPage } from './pages/FullCarDetailPage';
import { CeramicCoatingPage } from './pages/CeramicCoatingPage';
import { HeadlightRestorationPage } from './pages/HeadlightRestorationPage';
import { MobileDetailingPage } from './pages/MobileDetailingPage';
import { EngineBayDetailingPage } from './pages/EngineBayDetailingPage';
import { CityPage } from './pages/CityPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { ContentExportPage } from './pages/ContentExportPage';
import { FaqPage } from './pages/FaqPage';
export function App() {
  useEffect(() => {
    // Google Analytics (gtag.js)
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-BBSL5F5SDB';
    document.head.appendChild(script);
    const inlineScript = document.createElement('script');
    inlineScript.textContent = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-BBSL5F5SDB');
      gtag('config', 'AW-349742034');
    `;
    document.head.appendChild(inlineScript);
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="2znfyebhrc4op">
      <Routes data-id="element-1" data-mp="33m5be2yvvk7t">
        <Route path="/" element={<HomePage data-id="element-3" data-mp="33n6yx6x35z6f" />} data-id="element-2" data-mp="33lx0ggmbmoz9" />
        <Route path="/services/interior-detailing" element={<InteriorDetailingPage data-id="element-5" data-mp="38li619vzxvky" />} data-id="element-4" data-mp="33ork45xig5rm" />
        <Route path="/services/exterior-detailing" element={<ExteriorDetailingPage data-id="element-7" data-mp="3dle4ktlxcut4" />} data-id="element-6" data-mp="38kglmet3bwqk" />
        <Route path="/services/full-car-detail" element={<FullCarDetailPage data-id="element-9" data-mp="nvstj3irmlvf" />} data-id="element-8" data-mp="3dmfozootytni" />
        <Route path="/services/ceramic-coating" element={<CeramicCoatingPage data-id="element-11" data-mp="nxx05t81tyze" />} data-id="element-10" data-mp="nur7k407oeyx" />
        <Route path="/services/headlight-restoration" element={<HeadlightRestorationPage data-id="element-13" data-mp="swq8z8ce51t8" />} data-id="element-12" data-mp="stuclog6yl6w" />
        <Route path="/services/mobile-detailing" element={<MobileDetailingPage data-id="element-15" data-mp="38kwyktgo3k7" />} data-id="element-14" data-mp="35oymvdpbcv8" />
        <Route path="/services/engine-bay-detailing" element={<EngineBayDetailingPage data-id="element-17" data-mp="3ucjc5sple9t7" />} data-id="element-16" data-mp="3ud1f186rfma3" />
        <Route path="/faq" element={<FaqPage data-id="element-19" data-mp="d4xq9hl3gfef" />} data-id="element-18" data-mp="d4o09u01u88q" />
        <Route path="/ventura-county/:slug" element={<CityPage data-id="element-21" data-mp="85l12q6r2w8o" />} data-id="element-20" data-mp="d45rxz0443kg" />
        {/* Documentation-only content export. Not linked in navigation, noindex. */}
        <Route path="/content-export" element={<ContentExportPage data-id="element-23" data-mp="3gm65dtoft15g" />} data-id="element-22" data-mp="3gl4qtf87pwiz" />
        <Route path="*" element={<NotFoundPage data-id="element-25" data-mp="3bmjsjlcitmx6" />} data-id="element-24" data-mp="3gj1sm7wwox36" />
      </Routes>
    </BrowserRouter>;
}